import { Action } from '__common/store/action';
import { ActionsObservable } from 'redux-observable';
import { AnyAction, Store } from 'redux';
import { PanelsActionTypes } from '__editor/panelsEditor/components/panels/panelsActionsConstants';
import { CursorActionTypes } from 'actionsConstants';
import { 
  ADD_PANELS_ACTION, 
  ADD_PANELS, 
  UPDATE_PANELS, 
  UPDATE_PANELS_ACTION,
  REMOVE_PANELS_ACTION, 
  LOAD_PANELS_ACTION, 
  REQUEST_ADD_PANELS_ACTION,
  CHANGE_DESIRED_TABLE_WIDTH,
  SET_PANELS_ARRAY_GRID_FOR_MOVEMENT,
  RESET_PANELS_ARRAY_FOR_MOVEMENT,
  REQUEST_ADD_PANELS,
  REMOVE_PANELS,
  RESET_PANELS_STATE,
} from './panelsActions';
import { isGroundProduct, isRMFamily, isULA, isRMIFIProduct, isEcoFoot2Plus, isMetalX, isSolarMount, isRM10, isRM10Evolution, isNxtHorizon, isGFT, isRM5, isRMDT, isSMTiltPR, isAscender, isRmGridflex10D, isRMGridFlex, isRmGridflex5Rwdi} from '__common/constants/products';
import { SET_ROW_SPACING, SET_COLUMN_SPACING } from '__editor/panelsEditor/actions';
import { Observable } from 'rxjs';
import { of } from 'rxjs/observable/of';
import groupBy from 'lodash/groupBy';
import flatten from 'lodash/flatten';
import { 
  CheckingImportedRoofStatus,
  createPanelArrayGrid,
  getPanelCollisionBounds, 
  getPanelRoofZoneForVirtualEdges,
  isPanelInsideOfRoofEdgesMemoized as isPanelInsideOfRoofEdges,
  openConfirmationModalForOverflowingModules,
} from './panels';
import { removePanelFromRtree, insertPanelIntoRtree, resetRTree } from './panelsCollisions';
import { gapLengthMeters } from './utils/drawGftPanelsInTables';
import sortBy from 'lodash/sortBy';
import { resetKdTree } from '__editor/panelsEditor/components/cursor/utils/kdTreeStore';
import { SAVE_ROOF_EDGES_POINTS } from '../background/backgroundActions';
import { getPanelsRange, arePanelsWithinRoofEdges } from './utils/calculatePanelsRange';
import { getOffsetInPixels } from './utils/rmOnBlankDesign';
import { shouldUpdateRoofEdgesOnPanelChange, shouldUseDesiredBuildingLengthWidth, shouldUseSetBackDistance } from '__editor/panelsEditor/panelsEditorHelper';
import { dispatch } from '__common/store';
import { removePanelsWithNoSiblings, filterPanels } from './utils/panelsManagment';
import { resetPanelCenterTree } from './utils/panelsCenterStore';
import { greaterThanEqualToProjectVersion } from '__common/utils/versionCompare/versionCompare';
import { VERSION_MAP } from '__common/utils/versionCompare/version_info';
import { checkObstructionZoneForPanelsInPanelEditor } from '../obstructions/obstructionsHelper';
import { recalculatePanelZones, recalculateRmZones } from './utils/recalculateZones';
import { isASCE716or722 } from '__common/constants/buildingCodes';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { _isULA } from '../cursor/utils/snapToGridHelper';
import { SET_TABLE_ROW_SPACING } from '../settings/settingsActions';
import { getTiltedModuleTableRowSpacings } from '../tiltedModule/tiltedModule';
import { feetsToMeters } from '__common/calculations/feetsToMeters';
import { constructGraph, addAttachmentsOnCornersAndEdgesForEachArray, splitArraysIntoSubarrays, constructGraphForRMDT } from './utils/dividePanelsintoSubArrays';
import _ from 'lodash';
import { degreesToRadians, inchesToMeters } from 'maths';
import { OPEN_CONFIRM_CLEAR_ARRAYS_MODAL, OPEN_DRAWER_PAGE, SET_PANELS_IN_OVERFLOWING_STATE, SET_ROOF_AREA_SEEN, SET_USER_CLICKED_YES_OR_NO } from 'actions';
import { getDetectedModuleSpacing, traversePanelsGraphAndUpdateSpacings } from './utils/panelSpacingsUpdate';
import { getPanelBounds, getRoofBoundsMemoized as getRoofBounds } from '../roofEdges/roofEdgesCollisions';
import { checkPanelCollisionWithSetBackDistance } from '../roofZones/utils/setBackDistanceCollisionDetections';
import { validateMaxAllowedPanels } from '__editor/components/roofsSelector/components/roofsSelectorSaveLoadProject/utils/validateMaxAllowedPanels';
import { loadSharingOptions } from 'projectDesign/components/projectConfiguration/fields/loadSharingType';
import { applySingleColumnPendingRemovalState, showSingleColumnPendingRemovalAlert } from './utils/singleColumnPendingRemoval';
import { CLEAR_PANELS_GEOMETRY_DIRTY } from '__editor/googleMapsRoofsSelector/googleMapsRoofsSelectorActions';

export function calculateWhichPanelsCanBeAdded(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
  return action$.ofType(PanelsActionTypes.REQUEST_ADD_PANELS)
    .switchMap((action: Action<REQUEST_ADD_PANELS_ACTION>) => {
      const {
        panels: {
          panels: existingPanels,
        },
        projectConfiguration: { productId, projectVersion },
        tiltedRoof: { roofPitch },
      } = store.getState();
      if (
        isRMFamily(productId) &&
        !isRMDT(productId) &&
        roofPitch === '---' &&
        greaterThanEqualToProjectVersion(
          projectVersion,
          VERSION_MAP['default_roofpitch_value_changes'],
        )
      ) {
        dispatch(OPEN_DRAWER_PAGE('module selection'));
        return Observable.empty();
      }
      if (validateMaxAllowedPanels((existingPanels?.length + action.payload.panels?.length) || 0)) {
        return of(RESET_PANELS_STATE());
      }
      const filteredPanels = filterPanels(action.payload.panels);
      const panels = [...existingPanels, ...filteredPanels];
      const panelsWithCollisionWithObstruction = checkObstructionZoneForPanelsInPanelEditor(panels);
      let panelsOnlyWithSiblings = removePanelsWithNoSiblings(panelsWithCollisionWithObstruction);
      if(isAscender(productId)) {
        dispatch(OPEN_DRAWER_PAGE('module selection'));
      }
      const newPanelIds = new Set(filteredPanels.map(panel => panel.id));
      const addedPanelIds = panelsOnlyWithSiblings
        .filter(panel => newPanelIds.has(panel.id))
        .map(panel => panel.id);
      return of(ADD_PANELS(panelsOnlyWithSiblings, addedPanelIds));
    });
}



export function updateRestrictedAreaWhenPanelsAdded(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
  return action$.ofType(PanelsActionTypes.ADD_PANELS, PanelsActionTypes.LOAD_PANELS, PanelsActionTypes.RESTORE_PANELS_COLLISIONS_BOUNDS)
  .filter((_) => isGroundProduct(store.getState().projectConfiguration.productId))
    .switchMap((action: Action<ADD_PANELS_ACTION>) => {
      const groups = groupBy<panelInState>(store.getState().panels.panels, (p: panelInState): number => p.groupId);
      const updatedPanels = flatten(Object.entries(groups).map(([groupId, panelsInGroup]) => {
        const panelsSortedByX = sortBy(panelsInGroup, (panel: panelInState) => panel.x);
        const { projectConfiguration: { projectEnvConfig: { tilt } } } = store.getState();

        // if the table reached a max available length we need to add gaps on each side of it, as we do when 
        // drawing with rubber band (in order to prevent creating 30+ pairs tables).

        // known issue #1 when you add 29 panel pairs using rubber band,
        // you can then add another 29 panel pairs using rubber band when you start snapping to the last panel.
        if (panelsSortedByX && panelsSortedByX.length) {
          const {
            background: { metersPerPixel }, 
            settings: { columnSpacing, rowSpacing, tableRowSpacing },
            projectConfiguration: { productId }
          } = store.getState();
          const restrictedAreaUpdatedPanels = panelsSortedByX.map((panel) => {
            const _tableRowSpacing = isGFT(productId)? tableRowSpacing : getTiltedModuleTableRowSpacings( tilt, panel.tableHeight);
            const _effective_row_spacing = isGFT(productId)? 0 : rowSpacing;
            removePanelFromRtree(panel.rTreeBounds);
            panel.rTreeBounds = getPanelCollisionBounds(panel, _effective_row_spacing, columnSpacing, metersPerPixel);
            getPanelCollisionBounds(panel, rowSpacing, columnSpacing, metersPerPixel);
            panel.rTreeBounds.minX -= (gapLengthMeters / metersPerPixel);
            panel.rTreeBounds.minY -= (_tableRowSpacing / metersPerPixel);
            panel.rTreeBounds.maxX += (gapLengthMeters / metersPerPixel);
            panel.rTreeBounds.maxY += (_tableRowSpacing / metersPerPixel);
            insertPanelIntoRtree(panel.rTreeBounds);
            return panel;
          });
          return restrictedAreaUpdatedPanels;
        }

        return panelsSortedByX;
      }));

      return of(UPDATE_PANELS(updatedPanels));
    });
}


export function resetKdTreeStoreOnRoofCleared(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
  return action$.ofType(PanelsActionTypes.RESET_PANELS_STATE)
    .mergeMap(() => {
      // reset kdTree to avoid snapping to already deleted modules.
      resetRTree();
      resetKdTree();
      resetPanelCenterTree();
      return Observable.empty<never>();
    });
}

export function resetVirtualRoofEdgesOnResetPanelState(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
  return action$.ofType(PanelsActionTypes.RESET_PANELS_STATE)
    .filter((action) => {
      const { 
        projectConfiguration: { 
          productId,
          projectVersion,
        },
        roofsSelector: {
          mapType,
        },
      } = store.getState();
  
      return shouldUpdateRoofEdgesOnPanelChange(mapType, productId, projectVersion);
    })
    .switchMap(() => of(SAVE_ROOF_EDGES_POINTS([])));
}

const getCurrentRoofId = (store: Store<appState>): number => store.getState().background.selectedRoofId;

const shouldRefreshLoadedPanelsAfterGeometryChange = (store: Store<appState>) => {
  const {
    drawingManager: {
      roofs,
    },
  } = store.getState();

  return Boolean(roofs?.[getCurrentRoofId(store)]?.panelsGeometryDirty);
};

const shouldRecalculateLoadedAsceZones = (store: Store<appState>) => {
  const {
    projectConfiguration: {
      projectEnvConfig: {
        building_code,
      },
    },
  } = store.getState();

  return isASCE716or722(building_code);
};

const shouldRunLoadTimePanelRefresh = (store: Store<appState>) =>
  shouldRecalculateLoadedAsceZones(store) || shouldRefreshLoadedPanelsAfterGeometryChange(store);

const isHistoryPanelLoad = (action: AnyAction) => action.type === PanelsActionTypes.LOAD_PANELS_FROM_HISTORY;

const usesRmSpecificZoneRecalculation = (store: Store<appState>) =>
  onlyAsce716RMproducts(store)({} as AnyAction) || onlyAsce716RMDTProduct(store)({} as AnyAction);

const onlyAsce716RMproducts = (store: Store<appState>) => (action: AnyAction): boolean => {
  const {
    projectConfiguration: { 
      productId,
      projectEnvConfig: {
        building_code,
      },
    },
  } = store.getState();

  return ((isRMFamily(productId) && isASCE716or722(building_code) && !isRMIFIProduct(productId)) || isRM10(productId) || isEcoFoot2Plus(productId) || isRM10Evolution(productId) || isRM5(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId));
};

const onlyAsce716RMDTProduct = (store: Store<appState>) => (action: AnyAction): boolean => {
  const {
    projectConfiguration: { 
      productId,
    },
  } = store.getState();

  return isRMDT(productId);
};

export function setRoofEdgesForRMIFIBlankDesign(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
  return action$.ofType(
    PanelsActionTypes.LOAD_PANELS,
  ).filter(() => {
    const {
      projectConfiguration: {
        productId,
        projectVersion
      },
      roofsSelector: {
        mapType,
      },
    } = store.getState();

    return (
      shouldUseDesiredBuildingLengthWidth(mapType, productId, projectVersion)
    );
  }).switchMap((action) => {

    const { background: { metersPerPixel, blank_map_building_length: length, blank_map_building_width: width, bgScale } } = store.getState();

    if (length && width) {
      let lengthPixels = feetsToMeters(length) / metersPerPixel;
      let widthPixels = feetsToMeters(width) / metersPerPixel;
      lengthPixels /= bgScale.x;
      widthPixels /= bgScale.x;
      const newRoofEdges: pixelPoint[] = [
        { x: -widthPixels/2, y: lengthPixels/2 },
        { x: widthPixels/2, y: lengthPixels/2 },
        { x: widthPixels/2, y: -lengthPixels/2 },
        { x: -widthPixels/2, y: -lengthPixels/2 },
      ];
      return(of(SAVE_ROOF_EDGES_POINTS(newRoofEdges)));
    }
    return Observable.empty();
  });
}

export function clearLoadedPanelsGeometryDirty(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
  return action$.ofType(PanelsActionTypes.LOAD_PANELS)
    .filter(() => shouldRefreshLoadedPanelsAfterGeometryChange(store))
    .switchMap(() => of(CLEAR_PANELS_GEOMETRY_DIRTY(getCurrentRoofId(store))));
}

const getPanels = (store: Store<appState>) => (action: Action<ADD_PANELS_ACTION|REMOVE_PANELS_ACTION|LOAD_PANELS_ACTION|UPDATE_PANELS_ACTION>): panelInState[] => {
  const { 
    panels: {
      panels: _panels,
    },
  } = store.getState();
  return _panels;
};

export function updateRoofEdgesForRMBlankDesign(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
  return action$.ofType(
    PanelsActionTypes.ADD_PANELS,
    PanelsActionTypes.REMOVE_PANELS,
    PanelsActionTypes.LOAD_PANELS,
    PanelsActionTypes.LOAD_PANELS_FROM_HISTORY,
  ).filter(() => {
    const { 
      projectConfiguration: { 
        productId,
        projectVersion,
      },
      roofsSelector: {
        mapType,
      },
      panels: {
        panels,
      },
    } = store.getState();

    return (
      shouldUpdateRoofEdgesOnPanelChange(mapType, productId, projectVersion) &&
      panels.length > 0
    );
  })
  .filter((action) => {
    // it doesn't make sense to recalculate the whole range
    // if the new panels are within existing range.
    const { 
      background: { 
        roofEdgesPixiCords,
        metersPerPixel,
      }, 
      projectConfiguration: {
        productId,
        projectEnvConfig : {
          setback_distance,
        },
      },
    } = store.getState();

    const offset = getOffsetInPixels(metersPerPixel, productId, setback_distance );
    const shouldRecalculateRange = !(
      arePanelsAdded(action) && 
      arePanelsWithinRoofEdges(roofEdgesPixiCords, action.payload.panels, offset)
    ); 

    return shouldRecalculateRange;
  }).switchMap((action) => {
    const { 
      background: { 
        bgScale, 
        metersPerPixel,
      }, 
      panels: { 
        panels,
      },
      projectConfiguration: {
        productId,
        projectEnvConfig : {
          setback_distance,
        },
      },
    } = store.getState();

    const offset = getOffsetInPixels(metersPerPixel, productId, setback_distance );

    const { minX, minY, maxX, maxY } = getPanelsRange(<panelInState[]>panels);

    const makePoint = (x: number, y: number): pixelPoint => ({
      // background is drawn on a different layer than panels
      // with different scale.
      x: x / bgScale.x, 
      y: y / bgScale.y,
    });
    const newRoofEdges: pixelPoint[] = [
      makePoint(minX - offset, minY - offset),
      makePoint(maxX + offset, minY - offset),
      makePoint(maxX + offset, maxY + offset),
      makePoint(minX - offset, maxY + offset),
    ];
    // We have to update roof edges BEFORE we recalculate roof zones.
    // Otherwise, they would be calculated according to the old edges.
    dispatch(SAVE_ROOF_EDGES_POINTS(newRoofEdges));

    if(isRMIFIProduct(productId)){
      return of(UPDATE_PANELS(panels));
    }

    const updatedPanels = (<panelInState[]>panels).map((panel) => {
      const roofZone = getPanelRoofZoneForVirtualEdges(panel);
      panel.roofZone = roofZone.zone;
      panel.edgeType = roofZone.edgeType;
      return panel;
    });

    return of(UPDATE_PANELS(updatedPanels));
  });
}

function arePanelsAdded(action: AnyAction): action is Action<ADD_PANELS_ACTION> {
  return action.type === PanelsActionTypes.ADD_PANELS;
}

const incrementallyUpdateRmAddGroups = (productId: number) =>
  isRM5(productId)
  || isRM10(productId)
  || isRM10Evolution(productId)
  || isEcoFoot2Plus(productId)
  || isRMGridFlex(productId)
  || isRmGridflex10D(productId)
  || isRmGridflex5Rwdi(productId);

const POSITION_PRECISION = 1;

const getPanelPositionKey = (x: number, y: number) => `${x.toFixed(POSITION_PRECISION)}-${y.toFixed(POSITION_PRECISION)}`;

const getAdjacentPanels = (
  panel: panelInState,
  panelsByPosition: Map<string, panelInState>,
  rowSpacingPx: number,
  columnSpacingPx: number,
) => {
  const positions = [
    [panel.x - columnSpacingPx - panel.width, panel.y],
    [panel.x + columnSpacingPx + panel.width, panel.y],
    [panel.x, panel.y - rowSpacingPx - panel.height],
    [panel.x, panel.y + rowSpacingPx + panel.height],
  ];

  return positions
    .map(([x, y]) => panelsByPosition.get(getPanelPositionKey(x, y)))
    .filter(Boolean) as panelInState[];
};

const getIncrementalAddedPanelsGroupUpdate = (
  panels: panelInState[],
  newPanelIds: number[],
  rowSpacingPx: number,
  columnSpacingPx: number,
) => {
  if (!newPanelIds.length) {
    return null;
  }

  const newPanelIdSet = new Set(newPanelIds);
  const panelsById = new Map(panels.map(panel => [panel.id, panel]));
  const panelsByPosition = new Map(panels.map(panel => [getPanelPositionKey(panel.x, panel.y), panel]));
  const visited = new Set<number>();
  const updatedPanelsById = new Map<number, panelInState>();
  const affectedGroupIds = new Set<number>();

  newPanelIds.forEach((panelId) => {
    if (visited.has(panelId)) {
      return;
    }

    const seedPanel = panelsById.get(panelId);
    if (!seedPanel) {
      return;
    }

    const stack = [seedPanel];
    const component: panelInState[] = [];
    const existingGroupIds = new Set<number>();

    while (stack.length) {
      const currentPanel = stack.pop();

      if (!currentPanel || visited.has(currentPanel.id)) {
        continue;
      }

      visited.add(currentPanel.id);
      component.push(currentPanel);

      if (!newPanelIdSet.has(currentPanel.id)) {
        existingGroupIds.add(currentPanel.groupId);
      }

      getAdjacentPanels(currentPanel, panelsByPosition, rowSpacingPx, columnSpacingPx).forEach((adjacentPanel) => {
        if (!visited.has(adjacentPanel.id)) {
          stack.push(adjacentPanel);
        }
      });
    }

    if (!component.length) {
      return;
    }

    const targetGroupId = existingGroupIds.size
      ? Math.min(...Array.from(existingGroupIds))
      : component[0].groupId;

    component.forEach((componentPanel) => {
      updatedPanelsById.set(
        componentPanel.id,
        componentPanel.groupId === targetGroupId
          ? componentPanel
          : { ...componentPanel, groupId: targetGroupId },
      );
    });

    affectedGroupIds.add(targetGroupId);
  });

  return {
    affectedGroupIds: Array.from(affectedGroupIds),
    affectedPanels: Array.from(updatedPanelsById.values()),
  };
};

export function checkTableWidthBounds(action$: ActionsObservable<AnyAction>, store: Store<appState>) : Observable<any> {
  return action$.ofType(CursorActionTypes.FLIP_CURSOR)
  .filter(() => {
    const { editorCursor: { landscape }, panels: { desiredTableWidth } } = store.getState();
    if(_isULA()){
      let widthInBound = true;
      if(landscape && desiredTableWidth >= 3 && desiredTableWidth <= 5){
        widthInBound = false;
      } else {
        if(!landscape && desiredTableWidth>=1 && desiredTableWidth<=3){
          widthInBound = false;
        }
      }
      return widthInBound;
    }
  }).switchMap((action)=>{
    return of(CHANGE_DESIRED_TABLE_WIDTH(null));
  });
}

export function UpdateTableRowSpacingBasedOnTableHeight(action$: ActionsObservable<AnyAction>, store: Store<appState>) : Observable<any> {
  return action$.ofType(PanelsActionTypes.CHANGE_DESIRED_TABLE_WIDTH, CursorActionTypes.FLIP_CURSOR)
  .filter(() => {
    const { projectConfiguration: { productId } } = store.getState();
    return isULA(productId);
  }).switchMap(()=>{
    const { projectConfiguration: { projectEnvConfig: { tilt } }, panels: { desiredTableWidth } } = store.getState();
    const tableRowSpacing = getTiltedModuleTableRowSpacings(tilt, desiredTableWidth);
    return of(SET_TABLE_ROW_SPACING(tableRowSpacing));
  });
}

export function getUpdatedPanelList(panels: panelInState[], rowSpacingPx, columnSpacingPx, productId?: number) {
  if (!panels || panels.length === 0) {
    return [];
  }
  const panels_ = [...panels];
  const graph = isRMDT(productId) ? constructGraphForRMDT(panels, rowSpacingPx, columnSpacingPx) : constructGraph(panels, rowSpacingPx, columnSpacingPx);
  const visited = splitArraysIntoSubarrays(graph);
  panels_.forEach(p=>{
    p.groupId = visited[p.id];
  });
  return panels_;
}

export function getUpdatedPanelListForAscender(panels: panelInState[], rowSpacingPx, columnSpacingPx) {
  if (!panels || panels.length === 0) {
    return [];
  }
  const panels_ = [...panels];
  const panelConfig = panels_[0].panelConfig;
  
  let visited = {}; 
  if (panelConfig === 1 || panelConfig === 2) {
    const graph = constructGraph(panels, rowSpacingPx, columnSpacingPx);
    visited = splitArraysIntoSubarrays(graph); }
  else {
    panels_.forEach(p=>visited[p.id]=p.groupId);
  }

  panels_.forEach(p=>{
    p.groupId = visited[p.id];
  });
  return panels_;
}


const shouldUpdatePanelGroupIdsToReflectActualGroups = (productId: number, tilt: number) => {
  return isMetalX(productId) || (isSolarMount(productId) && !(tilt || tilt === 0)) || 
    isEcoFoot2Plus(productId) || isRM10Evolution(productId) || isRM10(productId) || isNxtHorizon(productId) || isRM5(productId) || isSMTiltPR(productId)  ||  isAscender(productId) || isRmGridflex10D(productId)  || isRmGridflex5Rwdi(productId) || isRMGridFlex(productId) || isRMDT(productId);
};



export function updatePanelGroupIdsToReflectActualGroups(action$: ActionsObservable<AnyAction>, store: Store<appState>) : Observable<any> {
  return action$.ofType(PanelsActionTypes.ADD_PANELS, PanelsActionTypes.REMOVE_PANELS, PanelsActionTypes.LOAD_PANELS, PanelsActionTypes.LOAD_PANELS_FROM_HISTORY, PanelsActionTypes.UPDATE_PANELS)
  .filter((action) => {
    const { projectConfiguration: { productId, projectEnvConfig: { tilt } } } = store.getState();
    return (
      (action.type !== PanelsActionTypes.UPDATE_PANELS || action.payload?.type?.type === 'updateGroups') &&
      (action.type !== PanelsActionTypes.LOAD_PANELS || shouldRefreshLoadedPanelsAfterGeometryChange(store)) &&
      shouldUpdatePanelGroupIdsToReflectActualGroups(productId, tilt)
    );
  }).switchMap((action)=>{
    const { panels: { panels }, background: { metersPerPixel }, settings: { rowSpacing, columnSpacing }, projectConfiguration: { productId, projectEnvConfig }} = store.getState();
    let panels_ = [];
    const [rowSpacingPx, columnSpacingPx] = [rowSpacing/metersPerPixel, columnSpacing/metersPerPixel];

    if (action.type === PanelsActionTypes.ADD_PANELS && incrementallyUpdateRmAddGroups(productId)) {
      const groupUpdate = getIncrementalAddedPanelsGroupUpdate(
        panels,
        action.payload?.newPanelIds || [],
        rowSpacingPx,
        columnSpacingPx,
      );

      if (groupUpdate?.affectedPanels?.length) {
        return of(UPDATE_PANELS(groupUpdate.affectedPanels, {
          type: 'groupId',
          affectedGroupIds: groupUpdate.affectedGroupIds,
          affectedPanelIds: groupUpdate.affectedPanels.map(panel => panel.id),
          incremental: true,
        }));
      }
    }

    if (panels.length > 0){
      if (isAscender(productId)) {
        const panelsOnePType = panels.filter((p:panelInState) => p.panelConfig === 1 || p.panelConfig === 2);
        const panelsTwoPType = panels.filter((p:panelInState) => p.panelConfig === 3 || p.panelConfig === 4);
        panels_ = getUpdatedPanelListForAscender(panelsOnePType, rowSpacingPx, columnSpacingPx);
        panels_ = panels_.concat(...getUpdatedPanelListForAscender(panelsTwoPType, rowSpacingPx, columnSpacingPx));
      } else {
      const panelsLandscape = panels.filter((p:panelInState) => p.landscape);
      const panelsPortrait = panels.filter((p:panelInState) => !p.landscape);
      panels_ = getUpdatedPanelList(panelsLandscape, rowSpacingPx, columnSpacingPx, productId);
      panels_ = panels_.concat(...getUpdatedPanelList(panelsPortrait, rowSpacingPx, columnSpacingPx, productId));
      if ((isRMGridFlex(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)) && [loadSharingOptions.fmg.value, loadSharingOptions.dsa.value].includes(projectEnvConfig?.load_sharing_type) && !projectEnvConfig?.fully_adhered && projectEnvConfig?.allow_manual_attachments){
        panels_ = addAttachmentsOnCornersAndEdgesForEachArray(panels_, rowSpacingPx, columnSpacingPx, projectEnvConfig?.load_sharing_type);
      }
    }
    }
    return of(UPDATE_PANELS(panels_, {type: 'groupId'}));
  });
}

export function updatePanelSpacings(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any>{
  return action$.ofType(PanelsActionTypes.UPDATE_PANEL_SPACINGS)
  .filter(() => {
    const { projectConfiguration: { productId, projectEnvConfig: { tilt } } }  = store.getState();
    return (isSolarMount(productId) && !(tilt || tilt === 0)) || isEcoFoot2Plus(productId) || isRM10Evolution(productId) || isRM10(productId) || isNxtHorizon(productId) || isRM5(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId);
  }).switchMap((action)=>{
    const { panels: { panels }, background: { metersPerPixel }, settings: { rowSpacing: stateRowSpacing, columnSpacing: stateColumnSpacing } } = store.getState();
    const { rowSpacingInches, columnSpacingInches } = action.payload;
    const [rowSpacing, columnSpacing] = [inchesToMeters(rowSpacingInches), inchesToMeters(columnSpacingInches)]
    let panels_ = [...panels];
    const [rowSpacingPx, columnSpacingPx] = [rowSpacing/metersPerPixel, columnSpacing/metersPerPixel];

    if (panels.length > 0){

      const panelsLandscape = panels.filter((p:panelInState) => p.landscape);      
      const panelsPortrait = panels.filter((p:panelInState) => !p.landscape);
      
      const { detectedRowSpacingPx, detectedColumnSpacingPx } = getDetectedModuleSpacing({ panels, stateRowSpacing, stateColumnSpacing, metersPerPixel });

      const graphLandscape = constructGraph(panelsLandscape, detectedRowSpacingPx, detectedColumnSpacingPx);
      const graphPortrait = constructGraph(panelsPortrait, detectedRowSpacingPx, detectedColumnSpacingPx);
      
      const visited = {};
      const panelIdMap = {};
      panels_.forEach(p=>panelIdMap[p.id] = p);
      panels_.forEach(p=>visited[p.id]=0);

      graphLandscape.forEach(p=>!visited[p.id] && traversePanelsGraphAndUpdateSpacings({panel: p, rowSpacingPx, columnSpacingPx, panelIdMap, visited}));
      graphPortrait.forEach(p=>!visited[p.id] && traversePanelsGraphAndUpdateSpacings({panel: p, rowSpacingPx, columnSpacingPx, panelIdMap, visited}));
      
      return of(SET_ROW_SPACING(rowSpacing), SET_COLUMN_SPACING(columnSpacing), UPDATE_PANELS(panels_, {type: 'updateGroups'}));
    }
    return Observable.empty();
  });
}


export function detectInvalidPanels(action$: ActionsObservable<AnyAction>, store: Store<appState>) : Observable<any> {
  return action$.ofType(PanelsActionTypes.UPDATE_PANELS, PanelsActionTypes.REMOVE_PANELS, PanelsActionTypes.LOAD_PANELS)
  .filter((action) => {
    const { projectConfiguration: { projectEnvConfig: { helioscope_id }, productId } } = store.getState();
    return helioscope_id && (
      action.type === PanelsActionTypes.REMOVE_PANELS ||
      action.type === PanelsActionTypes.LOAD_PANELS ||
      action.payload?.type?.type === 'roofZone' ||
      action.payload?.type?.type === 'groupId' ||
      isRMDT(productId)
    );
  })
  .switchMap((action)=>{
    const {
      background: {
        roofEdges,
        cords,
        zoom,
        rotationDegrees,
        bgXY,
        roofEdgesPixiCords,
        selectedRoofId,
        metersPerPixel,
      },
      tiltedRoof: {
        roofPitch,
      },
      panels: { panels },
      roofsSelector: {mapType},
      projectConfiguration: {productId, projectEnvConfig: {tilt}, projectVersion},
      settings: {
        panelWidth,
        panelHeight,
      },
      drawingManager:{roofs}
    } = store.getState();

    let totalPanels = 0;
    const panelIdsToRemove = [];
    const roofBound = getRoofBounds({roofEdges, roofCenter: cords, roofEdgesPixiCords,  bgOffSet: {x: bgXY.x, y: bgXY.y}, zoom, rotationRadians:degreesToRadians(rotationDegrees), roofPitch, tilt, productId, mapType});
    for (let i=0; i<panels.length; i++) {
      const panel = panels[i];
      const panelBound = getPanelBounds(panel, true, bgXY.x, bgXY.y, metersPerPixel);
      const isPanelInsideRoof = isPanelInsideOfRoofEdges(
        {panelBound,
        roofBound,
        mapType, productId}
      );
      const isPanelCollidesSetbackDistance = shouldUseSetBackDistance(mapType, productId, projectVersion) ? checkPanelCollisionWithSetBackDistance(
        panel,
        true,
        roofEdges,
        selectedRoofId,
        cords,
        zoom,
        metersPerPixel,
        rotationDegrees,
        bgXY.x,
        bgXY.y,
        panelWidth,
        panelHeight,
        productId,
        true,
        roofPitch,
        roofEdgesPixiCords,
        mapType,
        tilt,
      ) : false;
      const isPanelColliding = !isPanelInsideRoof || isPanelCollidesSetbackDistance;
      if (isPanelColliding) { 
        totalPanels++;
        panelIdsToRemove.push(panel.id);
      }
    }

    if(totalPanels){
      dispatch(SET_PANELS_IN_OVERFLOWING_STATE(selectedRoofId, true, totalPanels, panelIdsToRemove));
    }
    
    if (totalPanels && window.location.href.includes("project/design") && roofs[selectedRoofId]?.isConfirmedYesorNo !== false) {
      openConfirmationModalForOverflowingModules(totalPanels, panelIdsToRemove, selectedRoofId);
    }
    else if(!totalPanels){
      dispatch(SET_PANELS_IN_OVERFLOWING_STATE(selectedRoofId, false, 0, []));
      if(panels.length > 0){
        dispatch(SET_ROOF_AREA_SEEN(selectedRoofId, true));
        CheckingImportedRoofStatus();
      }
    }
    return Observable.empty();

  });
}


export function updateRMDTPanelZone(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
  return action$.ofType(
    PanelsActionTypes.ADD_PANELS,
    PanelsActionTypes.REMOVE_PANELS,
    PanelsActionTypes.LOAD_PANELS,
    PanelsActionTypes.LOAD_PANELS_FROM_HISTORY,
  ).filter((action) => (
    action.type === PanelsActionTypes.LOAD_PANELS_FROM_HISTORY ||
    action.type !== PanelsActionTypes.LOAD_PANELS || shouldRunLoadTimePanelRefresh(store)
  ))
  .filter( onlyAsce716RMDTProduct( store ) ).map( getPanels( store ) ).switchMap( ( panels ) => {
    const {
      projectConfiguration: {
        productId,
      },
      settings: {
        rowSpacing, 
        columnSpacing,
      },
      background: {
        metersPerPixel,
      },
    } = store.getState();
    return fromPromise(
      recalculateRmZones( productId, rowSpacing,columnSpacing, metersPerPixel, panels, getCurrentRoofId( store ) ) );
  }).switchMap((updatedPanels) => of(UPDATE_PANELS(updatedPanels)));
}

export function updatePanelZone(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
  return action$.ofType(
    PanelsActionTypes.ADD_PANELS,
    PanelsActionTypes.LOAD_PANELS,
    PanelsActionTypes.LOAD_PANELS_FROM_HISTORY,
  )
    .filter((action) => {
      const { projectConfiguration: { productId } } = store.getState();
      return (
        !isGroundProduct(productId) &&
        !usesRmSpecificZoneRecalculation(store) &&
        (action.type === PanelsActionTypes.LOAD_PANELS_FROM_HISTORY ||
         action.type !== PanelsActionTypes.LOAD_PANELS || shouldRefreshLoadedPanelsAfterGeometryChange(store))
      );
    })
    .switchMap( ( panels ) => { 
    return fromPromise(
      recalculatePanelZones( store));
  }).switchMap((updatedPanels) => of(UPDATE_PANELS(updatedPanels)));
}

export function updateRmPanelZone(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
  return action$.ofType(
    PanelsActionTypes.UPDATE_PANELS,
    PanelsActionTypes.LOAD_PANELS,
    PanelsActionTypes.LOAD_PANELS_FROM_HISTORY,
  )
    .filter((action) => {
      if (isHistoryPanelLoad(action)) {
        const { projectConfiguration: { productId, projectEnvConfig: { tilt } } } = store.getState();
        return !shouldUpdatePanelGroupIdsToReflectActualGroups(productId, tilt);
      }

      if (action.type === PanelsActionTypes.LOAD_PANELS) {
        return shouldRunLoadTimePanelRefresh(store);
      }

      return action.payload?.type?.type === 'groupId';
    })
    .filter( onlyAsce716RMproducts( store ) ).switchMap((action) => {
      const panels = getPanels(store)(action as Action<ADD_PANELS_ACTION|REMOVE_PANELS_ACTION|LOAD_PANELS_ACTION|UPDATE_PANELS_ACTION>);
      const {
        projectConfiguration: {
          productId,
        },
        settings: {
          rowSpacing, 
          columnSpacing,
        },
        background: {
          metersPerPixel,
        },
      } = store.getState();
      const affectedGroupIds = action.type === PanelsActionTypes.UPDATE_PANELS
        ? action.payload?.type?.affectedGroupIds
        : undefined;
      const panelsToRecalculate = affectedGroupIds?.length
        ? panels.filter(panel => affectedGroupIds.includes(panel.groupId))
        : panels;

      if (!panelsToRecalculate.length) {
        return Observable.empty();
      }

      return fromPromise(
      recalculateRmZones(
        productId,
        rowSpacing,
        columnSpacing,
        metersPerPixel,
        panelsToRecalculate,
        getCurrentRoofId( store ),
      ) );
  }).switchMap((updatedPanels) => of(UPDATE_PANELS(updatedPanels, {type: 'roofZone'})));
}


export function setPanelsGroupArrangement(action$: ActionsObservable<AnyAction>, store: Store<appState>) : Observable<any> {
  return action$.ofType(PanelsActionTypes.SET_PANELS_ARRAY_FOR_MOVEMENT)
  .filter(() => {
    const { panels: { panelsToBeMoved } } = store.getState();
    return panelsToBeMoved.length > 0
  }).switchMap((action)=>{
    const { panels: { panelsToBeMoved, bays: { panelBayMapping }}} = store.getState();
    const {grid, toggleAttachmentsGrid, panelConfig} = createPanelArrayGrid(panelsToBeMoved, panelBayMapping);
    return of(SET_PANELS_ARRAY_GRID_FOR_MOVEMENT(grid, toggleAttachmentsGrid, panelConfig));
  });
}


export function restorePanelsAfterNoMovement(action$: ActionsObservable<AnyAction>, store: Store<appState>) : Observable<any> {
  return action$.ofType(PanelsActionTypes.RESTORE_PANELS_FOR_NO_MOVEMENT)
  .switchMap(() => of(RESET_PANELS_ARRAY_FOR_MOVEMENT()));
}
